import React, { useContext } from 'react';
import { useNavigate } from 'react-router-dom';
import { utility } from '../../../utility/utility';
import { LOCAL_STORAGE_KEY, OTT_POSTER_TYPE, VODTYPE } from '../../../constant';
import crown from '../../../images/crown.png';
import { PlatformContext } from '../../../contexts/platformContext';

const AssetCard = ({ ottAsset, ottSetting }) => {
    const navigate = useNavigate();

    const isFree = ottAsset.VodTypes?.SID === VODTYPE.FREE;
    // const isFree = Array.isArray(ottAsset.VodTypes) && ottAsset.VodTypes?.some(type => type.SID === VODTYPE.FREE);
    const canPlay = isFree || utility.getValue(LOCAL_STORAGE_KEY.user)?.PaymentPlan?.length > 0;
    const displayPlatform = useContext(PlatformContext);
    const onClick = () => {
        utility.onAssetClick(ottAsset, ottSetting, navigate, displayPlatform);
    };

    const posterUrl = utility.getPosterUrl(ottAsset.Posters, OTT_POSTER_TYPE.Landscape);
    const year = ottAsset.Year || '—';
    const duration = utility.formatMilliseconds(ottAsset.Duration);
    const language = Array.isArray(ottAsset.Languages) && ottAsset.Languages.length > 0
            ? ottAsset.Languages.join(', ')
            : '—';
    const platform = ottAsset.PlatformName || '';

    const getTitle = (title) => {
        if (typeof title === 'string') return title;
        if (Array.isArray(title) && title.length > 0) return title[0].value;
        if (typeof title === 'object' && title?.value) return title.value;
        return '—';
    };
    
    return (
        <div
            onClick={onClick}
            style={{
                cursor: 'pointer',
                borderRadius: '10px',
                overflow: 'hidden',
                position: 'relative',
                transition: 'transform 0.2s ease',
            }}
            onMouseEnter={e => e.currentTarget.style.transform = 'scale(1.05)'}
            onMouseLeave={e => e.currentTarget.style.transform = 'scale(1)'}
        >
            {/* Poster */}
            <div style={{ position: 'relative' }}>
                <img
                    src={posterUrl}
                    alt={ottAsset.Title}
                    style={{
                        width: '100%',
                        height: 'auto',
                        borderRadius: '8px',
                        objectFit: 'cover',
                        aspectRatio: '16/9',
                        display: 'block'
                    }}
                />
                {/* Crown icon */}
                {!isFree && (
                    <img
                        src={crown}
                        alt="Premium"
                        style={{
                            position: 'absolute',
                            top: '8px',
                            right: '8px',
                            height: '24px',
                            width: '24px',
                            zIndex: 1
                        }}
                    />
                )}
            </div>

            {/* Metadata */}
            <div style={{ marginTop: '8px', color: 'white', padding: '4px 2px' }}>
                <div style={{ fontWeight: '600', fontSize: '14px', whiteSpace: 'nowrap', overflow: 'hidden', textOverflow: 'ellipsis' }}>
                    {getTitle(ottAsset.Title)}
                </div>
                <div style={{ fontSize: '12px', color: '#aaa' }}>
                    {year} • {duration} • {language}
                </div>
                {platform && (
                    <div style={{ fontSize: '11px', color: '#666', marginTop: '2px' }}>
                        {platform}
                    </div>
                )}
            </div>
        </div>
    );
};

export default AssetCard;
